import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { RarityType } from 'app/student/game-section/constants/rarity-type';

@Component({
    selector: 'kh-reward-card',
    templateUrl: './reward-card.component.html',
    styleUrls: ['./reward-card.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RewardCardComponent implements OnInit {
  @Input()
  public iconPath?: string | string[];

  @Input()
  public count?: number;

  @Input()
  public rarity?: RarityType | string;

  @Input()
  public hiddenBg = false;

  public icons: string[] = [];

  public ngOnInit(): void {
    this.icons = Array.isArray(this.iconPath)
      ? [...this.iconPath]
      : this.iconPath
        ? [this.iconPath]
        : [];
  }
}
